/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicLootBoxPrize } from './PublicLootBoxPrize';
import {
    PublicLootBoxPrizeFromJSON,
    PublicLootBoxPrizeFromJSONTyped,
    PublicLootBoxPrizeToJSON,
    PublicLootBoxPrizeToJSONTyped,
} from './PublicLootBoxPrize';

/**
 * 
 * @export
 * @interface GetLootBoxConfigPrizesResponse
 */
export interface GetLootBoxConfigPrizesResponse {
    /**
     * 
     * @type {Array<PublicLootBoxPrize>}
     * @memberof GetLootBoxConfigPrizesResponse
     */
    prizes: Array<PublicLootBoxPrize>;
}

/**
 * Check if a given object implements the GetLootBoxConfigPrizesResponse interface.
 */
export function instanceOfGetLootBoxConfigPrizesResponse(value: object): value is GetLootBoxConfigPrizesResponse {
    if (!('prizes' in value) || value['prizes'] === undefined) return false;
    return true;
}

export function GetLootBoxConfigPrizesResponseFromJSON(json: any): GetLootBoxConfigPrizesResponse {
    return GetLootBoxConfigPrizesResponseFromJSONTyped(json, false);
}

export function GetLootBoxConfigPrizesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLootBoxConfigPrizesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'prizes': ((json['prizes'] as Array<any>).map(PublicLootBoxPrizeFromJSON)),
    };
}

export function GetLootBoxConfigPrizesResponseToJSON(json: any): GetLootBoxConfigPrizesResponse {
    return GetLootBoxConfigPrizesResponseToJSONTyped(json, false);
}

export function GetLootBoxConfigPrizesResponseToJSONTyped(value?: GetLootBoxConfigPrizesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prizes': ((value['prizes'] as Array<any>).map(PublicLootBoxPrizeToJSON)),
    };
}

